<template>
    <div class="lager">
        <router-view></router-view>
        <div class="lagertop"></div>
        <div class="lagerHolder">
            <div class="lagerButton" @click="openUploads" v-if="userLev.indexOf('6') > -1">uploads</div>
            <div class="lagerButton" @click="openNeuBestell" v-if="userLev.indexOf('6') > -1">Neue Bestellung</div>
            <div class="lagerButton" @click="openBestelluebersicht">Offene Bestellungen</div>
            <!-- <div class="lagerButton" @click="openBestand">Mindest Bestand</div> -->
            <div class="lagerButton" @click="openBestands" v-if="userLev.indexOf('6') > -1">Lagerübersicht</div>
            <div class="lagerButton" @click="openBestellfiles" v-if="userLev.indexOf('6') > -1">Bestelldokumente</div>
        </div>

    </div>
</template>

<script>

export default {
    components: {

    },
    data() {
        return {

        }
    },
    computed: {
        stao() {
            return this.$store.getters['user/userStao'];
        },
        userLev() {
            return this.$store.getters['user/autLev'];
        }

    },
    watch: {

    },
    methods: {
        openBestand() {
            this.$router.push('lager/minbestand/' + this.stao);
        },
        openQR() {
            this.$router.push('lager/artqr/' + this.stao);
        },
        openUploads() {
            this.$router.push('lager/upload/' + this.stao);
        },
        openBestands() {
            this.$router.push('lager/bestandsuebersicht/' + this.stao);
        },
        openNeuBestell() {
            this.$router.push('lager/neuebestellung/' + this.stao);
        },
        openBestelluebersicht() {
            this.$router.push('lager/bestelluebersicht/' + this.stao);
        },
        openBestellfiles() {
            this.$router.push('lager/bestellfiles/' + this.stao);
        }

    },
    beforeDestroy() {
    },
    created() {
    }
}
</script>

<style scoped lang="scss">

.lager{
    position: absolute;
    width: 100%;
    height: 100vh;
    /*overflow-y: scroll;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.lagerHolder{
    display: flex;
    flex-direction: column;
    width: 100%;
    /*height: 100vh;*/
    /* overflow-y: scroll; */
}

.lagerButton{
    width: 100%;
    font-size: 2rem;
    text-align: center;
    /*height: 3rem;*/
    cursor: pointer;
    padding: 0.625rem;
}
.lagerButton:hover{
    background-color: $color-gray;
}

.lagerButton:active{
    background-color: $color-green;
}

.lagertop{
    height: 70px;
}

@include medium{

    .lagertop{
        display: none;
    }
    .lagerHolder{
        width: 31rem;
        @include default-shadow;
    }
}

@include extra-large{

    .lagerHolder{
        width: 31rem;
        @include default-shadow;
        /*height: 80vh;*/
    }
}

</style>
